/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { Rating } from '@/components/Rating/Rating';
import { roundValueToPrecision } from '@/components/Rating/utils';
import { type ReviewStatistic } from '../../../interface/types';
import { Text, View } from '@az/starc-ui';
import { useRef } from 'react';

type ReviewStatisticsProps = {
  reviewStatistic: ReviewStatistic;
  showReviewCount?: boolean;
};

export const ReviewStatistics = ({ reviewStatistic, showReviewCount }: ReviewStatisticsProps) => {
  const averageRating = reviewStatistic.averageOverallRating || '0';
  const reviewCount = Number(reviewStatistic.totalReviewCount || '0');
  const ratingValue = roundValueToPrecision(Number(averageRating), 0.1);
  const anchor = useRef<HTMLDivElement>(null);

  return (
    <View direction={'row'} align={'center'} attributes={{ ref: anchor }}>
      <Text variant="display-3" className={styles.average} attributes={{ 'aria-hidden': true }}>
        {ratingValue}
      </Text>
      <View padding={[1, 0, 1, 2]} className={styles.rating}>
        <Rating value={ratingValue} showStarFractions filledColor="#F26D0D" emptyColor="#D6D6D6" />
      </View>
      {showReviewCount ? <Text className={styles.reviewCount}>{`(${reviewCount})`}</Text> : null}
    </View>
  );
};
